export const CLUSTER_PAGE_MESSAGES = {
  PRIVATE_CLUSTER:
    "The control plane of this cluster is not accessible through the internet. Private control planes are currently not supported.",
  DELETED_CLUSTER:
    "This cluster has been deleted. If you think this is an error, please contact support or check the connection configuration.",
};

export const K8S_LENS_GLOSSARY = {
  TOTAL_SPEND: "Total cost of clusters with active Kubernetes Lens agents.",
  POD_WASTE: "Total cost of overprovisioned pods across clusters.",
  SAVINGS_POTENTIAL: "Potential savings from all clusters divided by the total spend.",
  POTENTIAL_SAVINGS: "Estimated savings based on PerfectScale recommendations.",
};
